// src/components/Footer.tsx
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const githubRepoUrl = "https://github.com/onchainexpat/topsignal"; // Project's GitHub repo

  return (
    <footer className="bg-dashboard-card-light dark:bg-dashboard-card-dark border-t border-dashboard-border-light dark:border-dashboard-border-dark mt-8 py-4">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-dashboard-text-muted-light dark:text-dashboard-text-muted-dark">
              &copy; {currentYear} Crypto Top Signals Dashboard. All rights reserved.
            </p>
          </div>
          
          <div className="flex items-center space-x-4">
            {/* Removed placeholder links for Docs, API, Privacy as they don't have actual destinations yet */}
            {/* Kept GitHub link and pointed it to the project repository */}
            <a 
              href={githubRepoUrl}
              target="_blank" // Open in new tab
              rel="noopener noreferrer" // Security best practice for target="_blank"
              className="text-sm text-dashboard-text-muted-light dark:text-dashboard-text-muted-dark hover:text-ethereum transition-colors"
              title="GitHub Repository"
            >
              GitHub
            </a>
          </div>
        </div>
        
        <div className="mt-4 text-center text-xs text-dashboard-text-muted-light dark:text-dashboard-text-muted-dark">
          <p>
            Market data provided by CoinGecko and various APIs. Not financial advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
